module.exports = __webpack_public_path__ + "img/roxen2021.8adb83e5.jpg";